<div style="display: flex; flex-direction: column; justify-content: start; align-items: stretch; margin-top: 50px" [formGroup]="quizForm">
  <div style="width: 95%; margin-left: 2%;">
    <div style="display: flex; flex-direction: row; gap: 30px; justify-content: start; align-items: stretch">
      <mat-form-field style="flex:30" appearance="fill">
        <mat-label>Solution Name</mat-label>
        <input matInput type="text" formControlName="name" name="name" />
      </mat-form-field>

      <mat-form-field style="flex:30" appearance="fill">
        <mat-label>Cost</mat-label>
        <mat-select formControlName="cost" style="margin-top: 5px;">
          <mat-option *ngFor="let cost of costOptions" [value]="cost">
            {{cost}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="flex:30" appearance="fill">
        <mat-label>Config Details</mat-label>
        <mat-select formControlName="configDetails" style="margin-top: 5px;">
          <mat-option *ngFor="let option of configDetailOptions" [value]="option">
            {{option}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div style="margin-top: 10px;">
    <mat-form-field style="width: 90%; margin-left: 2%;">
      <mat-label>Description</mat-label>
      <input matInput type="text" formControlName="description" name="description" />
    </mat-form-field>
  </div>
</div>

  <div *ngIf="entity.recommendedSolutionId">
    <div class="splitter">Control Items</div>
    <p-table
      [value]="entity.controlItemReferences"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Control ID</th>
          <th>Framework</th>
          <th style="width: 3em;"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{item.controlId}}</td>
          <td>{{item.complianceAreaName}}</td>
          <td>
            <button
              type="button"
              pButton
              class="risksponge-button"
              (click)="removeReference(item)"
              icon="pi pi-trash">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <div>
      <button
        type="button"
        pButton
        class="risksponge-button"
        (click)="addReference()"
        icon="pi pi-plus">
      </button>
    </div>
  </div>

  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
    <button mat-raised-button (click)="generate()">Ok</button>
  </div>
